import { render, staticRenderFns } from "./flowProductListComponent.vue?vue&type=template&id=1a5500db&scoped=true&"
import script from "./flowProductListComponent.vue?vue&type=script&lang=js&"
export * from "./flowProductListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5500db",
  null
  
)

export default component.exports